import styled from "styled-components"

export default {
    "Wrapper": styled.div`
        width: fit-content;
        display: flex;
        gap: 24px;
    `,
    "PageBtnWrapper": styled.div`
        display: flex;
        gap: 4px;
    `,
    "PageBtn": styled.button`
        ${({ theme }) => theme.font.small}
        width: 32px;
        height: 32px;
        line-height: 1;
        border-radius: 4px;
        color: ${({ theme, $active }) => $active && theme.color.white};
        background-color: ${({ theme, $active }) => $active && theme.color.major};
    `,
    "MoveBtn": styled.button`
        display: flex;
        align-items: center;
        gap: 8px;
        ${({ theme }) => theme.font.small}
        color: ${({ theme, $active }) => !$active && theme.color.grey3};
        cursor: ${({ $active }) => !$active && "auto"};
    `,
}